import React from "react";
import { useActivitiesData } from "./ActivitiesDataContext";

const HrmLoanAlert = {
  fields: {
    icon: { type: "text" as const },
    showProductName: {
      type: "radio" as const,
      options: [
        { label: "Show", value: true },
        { label: "Hide", value: false },
      ],
    },
  },
  defaultProps: {
    icon: "📍",
    showProductName: true,
  },
  render: (props: any) => {
    const { hrmLoanStatus, loading } = useActivitiesData();

    // Don't show anything while loading
    if (loading) return null;

    // Only show alert if there's a current HRM loan
    if (!hrmLoanStatus?.currentHrmDeviceNumber) {
      return null;
    }

    const icon = props?.icon ?? "📍";
    const showProductName = props?.showProductName !== false;
    const deviceNumber = hrmLoanStatus.currentHrmDeviceNumber;
    const productName = hrmLoanStatus.currentHrmProductName;

    return (
      <div
        ref={props.puck?.dragRef}
        className="mb-4 sm:mb-6"
      >
        <div className="rounded-xl bg-gradient-to-r from-emerald-50 to-teal-50 border border-emerald-200 p-4 sm:p-5 shadow-sm">
          <div className="flex items-start gap-3 sm:gap-4">
            <div className="text-2xl sm:text-3xl flex-shrink-0">{icon}</div>
            <div className="flex-1 min-w-0">
              <h4 className="text-emerald-900 font-semibold text-sm sm:text-base mb-1">
                Your Assigned Heart Rate Monitor
              </h4>
              <p className="text-emerald-800 text-sm sm:text-base leading-relaxed">
                You have been assigned{" "}
                {showProductName && productName ? (
                  <span className="font-medium">{productName}</span>
                ) : (
                  <span className="font-medium">HRM</span>
                )}{" "}
                <span className="inline-flex items-center px-2 py-0.5 rounded-full bg-emerald-100 text-emerald-800 font-bold text-sm border border-emerald-300">
                  #{deviceNumber}
                </span>
              </p>
              <p className="text-emerald-700 text-xs sm:text-sm mt-2 opacity-90">
                Please ensure you use this HRM for your activities to enable accurate activity tracking.
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  },
};

export default HrmLoanAlert;